var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bottom",
    d: "M11.999 14C13.5578 14 14.8161 12.66 14.8161 11V5C14.8161 3.34 13.5578 2 11.999 2C10.4402 2 9.18187 3.34 9.18187 5V11C9.18187 12.66 10.4402 14 11.999 14ZM17.5487 11C17.0886 11 16.7036 11.36 16.6285 11.85C16.2435 14.2 14.3184 16 11.999 16C9.67957 16 7.75453 14.2 7.36952 11.85C7.2944 11.36 6.90939 11 6.44926 11C5.87645 11 5.42571 11.54 5.51022 12.14C5.97035 15.14 8.22405 17.49 11.06 17.92V20C11.06 20.55 11.4825 21 11.999 21C12.5155 21 12.938 20.55 12.938 20V17.92C15.7739 17.49 18.0276 15.14 18.4878 12.14C18.5817 11.54 18.1216 11 17.5487 11Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 14,
    height: 19
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2,
    width: 13,
    height: 19,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "top",
    d: "M11.999 14C13.5578 14 14.8161 12.66 14.8161 11V5C14.8161 3.34 13.5578 2 11.999 2C10.4402 2 9.18187 3.34 9.18187 5V11C9.18187 12.66 10.4402 14 11.999 14ZM17.5487 11C17.0886 11 16.7036 11.36 16.6285 11.85C16.2435 14.2 14.3184 16 11.999 16C9.67957 16 7.75453 14.2 7.36952 11.85C7.2944 11.36 6.90939 11 6.44926 11C5.87645 11 5.42571 11.54 5.51022 12.14C5.97035 15.14 8.22405 17.49 11.06 17.92V20C11.06 20.55 11.4825 21 11.999 21C12.5155 21 12.938 20.55 12.938 20V17.92C15.7739 17.49 18.0276 15.14 18.4878 12.14C18.5817 11.54 18.1216 11 17.5487 11Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.6fb9034ed614df6629a0a2a4778adc23.svg";
export { ForwardRef as ReactComponent };